export default "__VITE_ASSET__DkdNGXtO__"